import React from "react";
import { FaDownload } from "react-icons/fa";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { pdfjs } from "react-pdf";

const IoT = () => {
  return (
    <div className="p-1 md:p-5 bg-kids h-fit flex flex-col items-center justify-center relative overflow-hidden">
      <div className="mt-8">
        <div
          id="reveal"
          className="mt-4 text-center md:bg-white border border-gray-200 rounded-lg relative"
        >
          <h2 className="text-2xl font-semibold text-gray-800 mb-3">
            Ikusasa Technology Solutions:The Impact of Mobile Technology in
            Higher Education Conference & Exhibition – 2025
          </h2>

          {/* PDF Viewer */}
          <div className="bg-gray-900 flex items-center justify-end  p-1 text-white hover:text-gray-400">
            {" "}
            <a
              href="IOT Monitoring System Documentatrion.pdf" // Path to your PDF
              download="IOT Monitoring System Documentatrion.pdf" // Filename for download
              className="  transition-colors duration-300"
            >
              <FaDownload className="text-3xl w-5 mr-10 " />
            </a>
          </div>
          <div className="relative w-full mi-h-screen sm:h-[90vh] border border-gray-200  overflow-hidden">
            <Worker
              workerUrl={`https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`}
            >
              <Viewer fileUrl="IOT Monitoring System Documentatrion.pdf" />
            </Worker>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IoT;
